import gql from 'graphql-tag'

export const fetchProductsSearchQuery = gql(`
  query (
    $sku: [String]
    $search: String
    $sort: ProductAttributeSortInput
    $brand: [String]
    $category_id: [String]
    $category_uid: [String]
    $filter_packaging: [String]
    $packaging: [String]
    $sub_brand: [String]
    $volume: [String]
    $currentPage: Int!
    $pageSize: Int = 5
    $product_last: String
    $product_new: String
    $product_sale: String
    $product_recommended: String
    $product_type: String
    $product_special: String
  ) {
    products(
      search: $search
      filter: {
        sku: { in: $sku }
        type_id: {eq: $product_type}
        brand: { in: $brand }
        sub_brand: { in: $sub_brand }
        category_id: { in: $category_id }
        category_uid: { in: $category_uid }
        filter_packaging: { in: $filter_packaging }
        packaging: { in: $packaging }
        volume: { in: $volume }
        product_last: { eq: $product_last }
        product_new: { eq: $product_new }
        product_sale: { eq: $product_sale }
        product_recommended: { eq: $product_recommended }
        product_special: { eq: $product_special }
      }
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $sort
    ) {
      items {
        sku
        volume_fe
        your_price_tax
        volume
        catalog_product_name
        name
        filter_packaging
        product_last
        product_new
        product_sale
        product_recommended
        product_special
        small_image {
          url
        }
        ... on BundleProduct {
          bundle_price_sum_tax
        }
      }
    }
  }
`)
